import { render } from "./paradigm.vue?vue&type=template&id=68e6caa2"
import script from "./paradigm.vue?vue&type=script&lang=js"
export * from "./paradigm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__